/* Packages */
import React from 'react';
import { render } from 'react-dom';

const brandModelFilterNodes = Array.from(document.querySelectorAll('[data-brand-model-filter]'));
if (brandModelFilterNodes.length) {
    import(/* webpackChunkName: "BrandModelFilter" */ './components/./BrandModelFilter').then(({ default: BrandModelFilter }) => {
        brandModelFilterNodes.forEach((node) => render(<BrandModelFilter {...(JSON.parse(node.dataset.brandModelFilter || '{}'))} />, node));
    });
}